import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
  Fragment
} from "react";

import AgentLayout from "./components/AgentLayout";
import { useDispatch, useSelector } from "react-redux";
import { refreshSessionData } from "../../utils/refreshSessionData";
import { NumericFormat } from "react-number-format"; // Updated import
import { isMobile } from "react-device-detect";
import axiosInstance from "../../utils/axiosInstance";
import { useParams, Link } from "react-router-dom";

export default function Home() {
  const [activeIndex, setActiveIndex] = useState(0);

  const [userSearchQuery, setUserSearchQuery] = useState("");
  const [userSearchResults, setUserSearchResults] = useState([]);
  const [userSearchLoading, setUserSearchLoading] = useState(false);
  const [userSearchOpen, setUserSearchOpen] = useState(false);
  const [selectedSearchUser, setSelectedSearchUser] = useState(null);
  const [breadcrumbPath, setBreadcrumbPath] = useState([]);
  const userSearchWrapRef = useRef(null);

  const [CDPopUpOPen, setCDPopUpOPen] = useState(false);
  const [showHideColumn, setShowHideColumn] = useState(false);
  const [rowLoading, setRowLoading] = useState(false);
  let childWindowRef = useRef(null);
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userStore);
  const eventsFromParent = useSelector((state) => state.event);
  const loginUserId = userInfo.data?._id;

  // Refresh all slices (user, events, exposure) whenever /agent/dashboard is visited.
  useEffect(() => {
    if (!loginUserId) return;
    refreshSessionData(dispatch).catch((err) => {
      console.error("AgentDashboard: slice refresh failed:", err);
    });
  }, [loginUserId, dispatch]);

  const showHideDiv = (index) => {
    setActiveIndex(index === activeIndex ? activeIndex : index);
  };

  let cricketList = [];
  let tennisList = [];
  let footballList = [];
  let horseList = [];
  let greyList = [];

  if (
    eventsFromParent !== null &&
    eventsFromParent?.data != null &&
    eventsFromParent?.data != undefined
  ) {
    cricketList = eventsFromParent?.data?.result
      .filter((event) => event.sports_type === 1)
      .sort((a, b) => b.inplay - a.inplay);
    footballList = eventsFromParent?.data?.result
      .filter((event) => event.sports_type === 2)
      .sort((a, b) => b.inplay - a.inplay);
    tennisList = eventsFromParent?.data?.result
      .filter((event) => event.sports_type === 3)
      .sort((a, b) => b.inplay - a.inplay);
  }
  const [bgColor, setBgColor] = useState(false);
  useEffect(() => {
    if (isMobile) {
      setBgColor("#ffffff");
    } else {
      setBgColor("#06b281");
    }
  });

  useEffect(() => {
    let cancelled = false;
    const q = userSearchQuery.trim();
    if (q.length < 2) {
      setUserSearchResults([]);
      setUserSearchOpen(false);
      return;
    }
    const timer = setTimeout(async () => {
      setUserSearchLoading(true);
      try {
        const res = await axiosInstance.get("/company/search-downline-users", {
          params: { q }
        });
        if (cancelled) return;
        const list = Array.isArray(res.data?.users) ? res.data.users : [];
        const selectionLocked =
          selectedSearchUser && q === (selectedSearchUser.uname || "").trim();
        if (selectionLocked) {
          setUserSearchResults([]);
          setUserSearchOpen(false);
        } else {
          setUserSearchResults(list);
          setUserSearchOpen(list.length > 0);
        }
      } catch {
        if (!cancelled) {
          setUserSearchResults([]);
          setUserSearchOpen(false);
        }
      } finally {
        if (!cancelled) setUserSearchLoading(false);
      }
    }, 300);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [userSearchQuery, selectedSearchUser]);

  useEffect(() => {
    const onDocMouseDown = (e) => {
      if (
        userSearchWrapRef.current &&
        !userSearchWrapRef.current.contains(e.target)
      ) {
        setUserSearchOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocMouseDown);
    return () => document.removeEventListener("mousedown", onDocMouseDown);
  }, []);

  const selectUserFromSuggest = useCallback((u) => {
    if (!u?._id) return;
    setSelectedSearchUser(u);
    setUserSearchQuery(u.uname || "");
    setUserSearchResults([]);
    setUserSearchOpen(false);
  }, []);

  const loadMore = useCallback(async () => {}, []);

  useEffect(() => {
    setBreadcrumbPath([]);
    setSelectedSearchUser(null);
    setUserSearchQuery("");
  }, [loginUserId]);

  useEffect(() => {
    const listener = (event) => {
      if (event.data?.type !== "" && event.data?.type !== undefined) {
        if (childWindowRef.current && !childWindowRef.current.closed) {
          childWindowRef.current.close();
          childWindowRef.current = null;
          let userId = event.data?._id;
          let type = event.data?.type;
          openLedgerPopUp(userId, type);
        }
      }
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, []);

  const handleCreditDebit = async (row) => {
    let userId = row._id;
    childWindowRef.current = window.open(
      "/agent/popup-page/cd/" + userId,
      "",
      "width=660,height=750"
    );
    if (childWindowRef.current) {
      childWindowRef.current.document.title = "Hawala (Cash) BPEXCH";
    }
  };

  const openLedgerPopUp = async (id, type) => {
    let popup = null;
    if (type == "CashDeposit" || type == "CashWithdrawal") {
      popup = window.open(
        "/agent/popup-page/le/" + id,
        "",
        "width=900,height=800"
      );
    } else {
      popup = window.open(
        "/agent/popup-page/crle/" + id,
        "",
        "width=900,height=800"
      );
    }

    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const handleLedger = async (row) => {
    let userId = row._id;
    openLedgerPopUp(userId);
  };

  const executeUserSearch = useCallback(async () => {
    const target = selectedSearchUser;
    if (!target?._id || !loginUserId) return;
    setUserSearchLoading(true);
    try {
      const res = await axiosInstance.get(
        `/company/user-breadcrumb/${target._id}`,
        { params: { from: loginUserId } }
      );
      const path = Array.isArray(res.data?.path) ? res.data.path : [];

      setBreadcrumbPath(path);
      setUserSearchOpen(false);
    } catch {
      setBreadcrumbPath([]);
    } finally {
      setUserSearchLoading(false);
    }
  }, [selectedSearchUser, loginUserId]);

  const searchSelectionLocked =
    !!selectedSearchUser &&
    userSearchQuery.trim() === (selectedSearchUser.uname || "").trim();

  return (
    <AgentLayout>
      <>
        <div className="container-fluid">
          <div className="animated fadeIn">
            <style
              dangerouslySetInnerHTML={{
                __html:
                  ".rightMenu {position: absolute; float: right;top: 0;left: 160px;}.bcicustom {             float: left;            margin: auto 0px;        }         .bccustom2 {             margin-top: -6px;         }        @media screen and (max-width: 635px) {            #breadcrumbcustom { margin-top: -16px;             }         }   .blink_me {             animation: blinker 1s linear infinite; }         @keyframes blinker {             50% {                opacity: 0.3;             }        } "
              }}
            />

            <div>
              <div className="card col-12" id="Usersearchcustom">
                <div className="card-header">
                  <i className="fa fa-filter" />
                  <strong class="site_family">Search-Users</strong>
                </div>
                <div
                  className="card-body"
                  style={{ paddingBottom: 0, margin: 0 }}
                >
                  <div id="searchUsers" className="row">
                    <div className="col-md-6 col-12">
                      <form
                        autoComplete="off"
                        className="form-horizontal"
                        style={{ padding: "7px" }}
                      >
                        <div className="form-group row">
                          <div className="col-10 autocomplete">
                            <div
                              className="input-group"
                              style={{ width: "77%" }}
                            >
                              <div
                                className="inputWithIcon position-relative"
                                style={{ flex: "1 1 0", minWidth: 0 }}
                              >
                                <input
                                  type="text"
                                  placeholder="Username"
                                  id="myInput"
                                  className="form-control ui-autocomplete-input site_family"
                                  autoComplete="off"
                                  value={userSearchQuery}
                                  onChange={(e) => {
                                    const v = e.target.value;
                                    setUserSearchQuery(v);
                                    if (
                                      selectedSearchUser &&
                                      v.trim() !==
                                        (selectedSearchUser.uname || "").trim()
                                    ) {
                                      setSelectedSearchUser(null);
                                    }
                                  }}
                                  onFocus={() => {
                                    if (
                                      !searchSelectionLocked &&
                                      userSearchResults.length > 0
                                    ) {
                                      setUserSearchOpen(true);
                                    }
                                  }}
                                  aria-controls="user-search-suggest-list"
                                  aria-expanded={userSearchOpen}
                                />
                                {userSearchOpen &&
                                  !searchSelectionLocked &&
                                  userSearchQuery.trim().length >= 2 &&
                                  userSearchResults.length > 0 && (
                                    <ul
                                      id="user-search-suggest-list"
                                      className="list-group position-absolute shadow-sm border bg-white mt-1 site_family"
                                      role="listbox"
                                      style={{
                                        zIndex: 1050,
                                        left: 0,
                                        top: "100%",
                                        width: "100%",
                                        maxHeight:
                                          "calc(100vh - 12rem - env(safe-area-inset-bottom, 0px))",
                                        minHeight: 0,
                                        overflowY: "auto",
                                        WebkitOverflowScrolling: "touch",
                                        boxSizing: "border-box"
                                      }}
                                    >
                                      {userSearchResults.map((u) => (
                                        <li
                                          key={u._id}
                                          role="option"
                                          className="list-group-item list-group-item-action py-1 px-3 site_family"
                                          style={{ cursor: "pointer" }}
                                          onMouseDown={(e) =>
                                            e.preventDefault()
                                          }
                                          onClick={() =>
                                            selectUserFromSuggest(u)
                                          }
                                        >
                                          {u.uname}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                              </div>

                              <span className="input-group-prepend">
                                <button
                                  id="myBtn"
                                  type="button"
                                  className="btn btn-primary site_family"
                                  onClick={() => executeUserSearch()}
                                >
                                  <i className="fa fa-search"></i> Search
                                </button>
                              </span>
                            </div>
                            {breadcrumbPath.length > 0 && (
                              <nav
                                aria-label="breadcrumb"
                                id="user_search"
                                className="d-flex flex-wrap align-items-center"
                                style={{
                                  flex: "1 1 12rem",
                                  minWidth: 0,
                                  padding: "6px 0"
                                }}
                              >
                                <div style={{ paddingRight: 8, minWidth: 0 }}>
                                  <Link
                                    to={`/agent/accounts/chart/${loginUserId}`}
                                    aria-label="Chart root"
                                  />
                                  {breadcrumbPath.map((seg, i) => {
                                    const isLast =
                                      i === breadcrumbPath.length - 1;
                                    return (
                                      <Fragment key={seg._id}>
                                        {i === 0 && !isLast ? null : " / "}
                                        {isLast ? (
                                          <Link
                                            target="_blank"
                                            className="site_family"
                                            style={{ color: "#00b181" }}
                                            to={
                                              seg.user_role == 8
                                                ? `/agent/edit/${seg._id}`
                                                : `/agent/accounts/chart/${seg._id}`
                                            }
                                          >
                                            <span>{seg.uname}</span>
                                          </Link>
                                        ) : (
                                          <Link
                                            target="_blank"
                                            className="site_family"
                                            style={{ color: "#00b181" }}
                                            to={
                                              seg.user_role == 8
                                                ? `/agent/edit/${seg._id}`
                                                : `/agent/accounts/chart/${seg._id}`
                                            }
                                          >
                                            {seg.uname}
                                          </Link>
                                        )}
                                      </Fragment>
                                    );
                                  })}
                                </div>
                                <div className="btn-group flex-shrink-0">
                                  <a
                                    className="btn btn-warning"
                                    onClick={() =>
                                      handleCreditDebit({
                                        _id: breadcrumbPath[
                                          breadcrumbPath.length - 1
                                        ]._id
                                      })
                                    }
                                    style={{
                                      display: "inline-block",
                                      fontWeight: "400",
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      verticalAlign: "middle",
                                      userSelect: "none",
                                      border: "1px solid transparent",
                                      padding: ".375rem .75rem",
                                      fontSize: ".875rem",
                                      lineHeight: "1.5",
                                      borderRadius: ".25rem",
                                      transition:
                                        "color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out"
                                    }}
                                  >
                                    <strong className="site_family">C</strong>
                                  </a>

                                  <Link
                                    to={`/agent/edit/${
                                      breadcrumbPath[breadcrumbPath.length - 1]
                                        ._id
                                    }`}
                                    className="btn btn-primary"
                                  >
                                    <i className="fas fa-pencil-alt"></i>
                                  </Link>
                                  <a
                                    className="btn btn-info"
                                    href={`ledger/${
                                      breadcrumbPath[breadcrumbPath.length - 1]
                                        .enc
                                    }`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleLedger({
                                        _id: breadcrumbPath[
                                          breadcrumbPath.length - 1
                                        ]._id
                                      });
                                    }}
                                  >
                                    <strong>L</strong>
                                  </a>
                                </div>
                              </nav>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                    <div
                      className="col-md-6 col-12"
                      style={{ padding: 0, height: 65 }}
                    >
                      <img
                        src="../assets/bp/preloader.gif"
                        style={{ height: 20, display: "none" }}
                      />
                      <nav
                        aria-label="breadcrumb"
                        id="user_search"
                        className="col-12 col-md-6"
                        style={{ display: "none" }}
                      ></nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="Bookmarkets">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header site_family">
                      <strong>Sport Highlights</strong>
                      <a
                        className="btn btn-sm btn-primary"
                        href={`/agent/dashboard`}
                      >
                        <strong
                          style={{ color: "white" }}
                          className="site_family"
                        >
                          Refresh
                        </strong>
                      </a>
                    </div>
                    <div className="card-body">
                      <table className="table table-bordered table-striped table-sm">
                        <thead>
                          <tr style={{ background: "white" }}>
                            <th class="site_family">Soccer</th>
                            <th class="site_family" style={{ width: "20%" }}>
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {footballList.map((football, index) => (
                            <tr
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "#f2f2f2" : "#fff"
                              }}
                            >
                              <td
                                className="site_family"
                                style={{
                                  border: "1px solid #c8ced3",
                                  fontSize: "17px",
                                  padding: "0.35rem"
                                }}
                              >
                                <a
                                  href={`/agent/market-analysis/${football.mid}`}
                                  style={{
                                    color: "#00b181",
                                    fontWeight: "500",
                                    fontSize: "1.09375rem"
                                  }}
                                >
                                  {football.name} / Match Odds
                                  {football.inplay == 1 ? (
                                    <i
                                      class="fa fa-circle position-plus"
                                      style={{
                                        color: "#0b6121",
                                        paddingLeft: "10px"
                                      }}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                </a>
                              </td>
                              <td
                                style={{
                                  border: "1px solid #c8ced3",
                                  textAlign: "left",
                                  padding: "0.35rem",
                                  color: "#0b6121"
                                }}
                                className="site_family"
                              >
                                <NumericFormat
                                  value={football.totalMatched}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <table
                        className="table table-bordered table-striped table-sm"
                        id="tbl_dashboard_tennis"
                      >
                        <thead>
                          <tr style={{ background: "white" }}>
                            <th class="site_family">Tennis</th>
                            <th class="site_family" style={{ width: "20%" }}>
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {tennisList.map((tennis, index) => (
                            <tr
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "#f2f2f2" : "#fff"
                              }}
                            >
                              <td
                                style={{
                                  border: "1px solid #c8ced3",
                                  fontSize: "17px",
                                  padding: "0.35rem"
                                }}
                                className="site_family"
                              >
                                <a
                                  href={`/agent/market-analysis/${tennis.mid}`}
                                  style={{
                                    color: "#00b181",
                                    fontWeight: "500",
                                    fontSize: "1.09375rem"
                                  }}
                                >
                                  {tennis.name} / Match Odds
                                  {tennis.inplay == 1 ? (
                                    <i
                                      class="fa fa-circle position-plus"
                                      style={{
                                        color: "#0b6121",
                                        paddingLeft: "10px"
                                      }}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                </a>
                              </td>
                              <td
                                style={{
                                  border: "1px solid #c8ced3",
                                  textAlign: "left",
                                  padding: "0.35rem",
                                  color: "#0b6121"
                                }}
                                className="site_family"
                              >
                                <NumericFormat
                                  value={tennis.totalMatched}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <table className="table table-bordered table-striped table-sm">
                        <thead>
                          <tr style={{ background: "white" }}>
                            <th class="site_family">Cricket</th>
                            <th class="site_family" style={{ width: "20%" }}>
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {cricketList.map((cricket, index) => (
                            <tr
                              class="site_family"
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "#f2f2f2" : "#fff"
                              }}
                            >
                              <td
                                style={{
                                  border: "1px solid #c8ced3",
                                  fontSize: "17px",
                                  padding: "0.35rem"
                                }}
                                className="site_family"
                              >
                                <a
                                  href={`/agent/market-analysis/${cricket.mid}`}
                                  style={{
                                    color: "#00b181",
                                    fontWeight: "500",
                                    fontSize: "1.09375rem"
                                  }}
                                >
                                  {cricket.name} / Match Odds
                                  {cricket.inplay == 1 ? (
                                    <i
                                      class="fa fa-circle position-plus"
                                      style={{
                                        color: "#0b6121",
                                        paddingLeft: "10px"
                                      }}
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                </a>
                              </td>
                              <td
                                className="site_family"
                                style={{
                                  border: "1px solid #c8ced3",
                                  textAlign: "left",
                                  padding: "0.35rem",
                                  color: "#0b6121"
                                }}
                              >
                                <NumericFormat
                                  value={cricket.totalMatched}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </AgentLayout>
  );
}
